import React, { Component } from 'react'
import { withNavBars } from '../../HOCs'
import  TimeOffRequest  from './timeOffrequest'

class TimeOffRequestParent extends Component {
    render() {
        return (
            <div>
                <TimeOffRequest />
            </div>
        )
    }
}
const props = {
    boxShadow: false
}
export default withNavBars(TimeOffRequestParent, props)